import ContentArticle from "@/components/content/ContentArticle";
import {
  contentPaths,
  contentProps,
  type ContentPageProps,
} from "@/utils/contentProps";

export default function BlogPost(props: ContentPageProps) {
  return <ContentArticle {...props} />;
}

export const getStaticPaths = contentPaths("blog");
export const getStaticProps = contentProps("blog");
